import React, { FC, PropsWithChildren, createContext, useContext } from 'react';
import { CardVariant } from './cardVariants';

const StripeCardVariantContext = createContext<CardVariant | null>(null);

export const StripeCardVariantProvider: FC<PropsWithChildren<{ variant: CardVariant | null }>> = ({ variant, children }) => (
    <StripeCardVariantContext.Provider value={variant}>{children}</StripeCardVariantContext.Provider>
);

export const useStripeCardVariant = (): CardVariant | null => useContext(StripeCardVariantContext);
